import { useCallback } from 'react';

export default function usePixel() {
	const excuteKakaoPixel = useCallback((tag = '') => {
		let count = 0;

		const intervalId = setInterval(() => {
			const { _kp_key, kakaoPixel } = window;

			if (kakaoPixel) {
				kakaoPixel(_kp_key).pageView(tag);
				clearInterval(intervalId);
			}

			try {
				count += 1;
				if (count > 50) {
					clearInterval(intervalId);
					throw new Error('카카오 픽셀 스크립트 로드 오류');
				}
			} catch (err) {
				console.log(err.message);
			}
		}, 100);
	}, []);

	const excuteFbPixel = useCallback((tag, type) => {
		let count = 0;
		const intervalId = setInterval(() => {
			const { fbq } = window;

			if (fbq) {
				fbq(type || 'trackCustom', tag);
				clearInterval(intervalId);
			}

			try {
				count += 1;
				if (count > 50) {
					clearInterval(intervalId);
					throw new Error('페이스북 픽셀 스크립트 로드 오류');
				}
			} catch (err) {
				console.log(err.message);
			}
		}, 100);
	}, []);

	return {
		excuteKakaoPixel,
		excuteFbPixel,
	};
}
